{
  "sdk-download-android": "Scarica per Android",
  "sdk-connect": "Collega",
  "sdk-download-ios": "Scarica per iOS",
  "sdk-install": "Installa",
  "sdk-modal-instruct-1": "1. Apri l'app Binance",
  "sdk-modal-instruct-2": "2. Tocca {{icon}} nella homepage",
  "sdk-modal-title": "Collega con Binance",
  "sdk-no-app": "Non hai ancora l'app Binance?"
}